/**
 * Limitar númerps de caracteres do texto.
 * @param text 
 * @param maxLength 
 * @returns text
 */

export default function TruncateText(text: string, maxLength: number) {
    if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
    } else {
        return text;
    }

}